'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const SmartyContent = require('../../shared/_layouts/_templates/_includes/smartyContent.jsx')
const Nav = require('../../shared/_layouts/_templates/_includes/nav.jsx')
const { smartyIncludes, smartyVariables } = require('../../shared/_layouts/_templates/_includes/smartyIncludes.jsx')
const getAirportInfo = require('../../shared/_layouts/_templates/_includes/getAirportInfo')
const Engine = require('../../shared/_layouts/_templates/_includes/engines/engine-controller.jsx')
// const ExitDiscountModal = require('../../shared/_layouts/_templates/_includes/modals/ExitDiscountModal.jsx')
const TrackerFix = require('../../shared/_layouts/_templates/_includes/trackerFix')
const Agents = require('../../_plugins/lib/agents')
const Helpers = require('../../_plugins/lib/helpers')
const getPhoneNumbers = require('../../_plugins/lib/phoneNumber')
const DiscountAlert = require('../../shared/_layouts/_templates/_includes/discount-alert.jsx')
const HarpAlert = require('../../shared/_layouts/_templates/_includes/harp-alert.jsx')
const { object } = PropTypes

const LandingPages = createReactClass({
  mixins: [Agents],

  propTypes: {
    domainSettings: object,
    formSettings: object,
    locations: object,
    RoomTypes: object,
    settings: object,
    pageData: object.isRequired,
    agents: object
  },

  getInitialState () {
    return {
      promotionCode: null
    }
  },

  setPromotionCode (code) {
    if (code === this.state.promotionCode) return
    this.setState({ promotionCode: code })
  },

  componentDidMount () {
    const { pageData: { html } } = this.props
    let { agentData: { agent } } = this.state
    const { setVar } = smartyVariables(html)
    if (setVar.agent) {
      agent = setVar.agent
      this.checkAgent(agent, this.updateAgentData)
    }
    let environment = 'production'
    if (Helpers.getParameterByName('data-pipeline-staging')) environment = 'staging'
    if (Helpers.getParameterByName('data-pipeline-production')) environment = 'production'
    TrackerFix({
      agent,
      environment,
      templateGroup: 'core',
      schemaVersions: {
        cache_primer: 'v1.0.0',
        initialise: 'v1.1.0',
        auto_capture: 'v1.1.0',
        capture: 'v1.0.0',
        click: 'v1.0.0',
        focus: 'v1.0.0',
        ipseity: 'v1.0.0',
        load: 'v1.1.0',
        test: 'v1.0.0',
        view: 'v1.0.0'
      }
    })
    window.universalJavascriptLoaded = true
  },

  getEngineProducts (setVar = { }) {
    if (setVar.engineProducts) return setVar.engineProducts.split(',')
    return false
  },

  render () {
    const { agentData, phoneNumbers, promotionCode } = this.state
    const { settings, pageData, agents: agentSettings, domainSettings, formSettings, locations, RoomTypes } = this.props
    const airport = getAirportInfo(pageData.pageName)
    let hiddenLocation = ''
    if (airport && airport.code) hiddenLocation = airport.code
    const { html } = pageData
    let { setVar, content } = smartyVariables(html)
    content = smartyIncludes(content)
    const productList = this.getEngineProducts(setVar)

    return (
      <div>
        <Nav promotionCodeCallback={this.setPromotionCode} agents={agentSettings} pageData={pageData} settings={settings} />
        <div id='booking-engine' className='row bg-default horizontal-container contentOnly'>
          <DiscountAlert settings={settings} agentData={agentData} />
          <HarpAlert domainSettings={domainSettings} settings={settings} />
          <h3 className='text-center' dangerouslySetInnerHTML={{ __html: setVar.pageTitle || pageData.pageTitle }} />
          {setVar.pageSubTitle && <span className='lead text-center block' dangerouslySetInnerHTML={{ __html: setVar.pageSubTitle }} />}
          <hr />
          {productList && (
            <Engine
              horizontal
              terminalLink
              showFlight
              showFlightDropdown
              productList={productList}
              setVar={setVar}
              domainSettings={domainSettings}
              formSettings={formSettings}
              locations={locations}
              RoomTypes={RoomTypes}
              hiddenLocation={hiddenLocation}
              pageData={pageData}
              agentSettings={agentSettings}
              agentData={agentData}
              promotionCode={promotionCode}
            />
          )}
          <div className='clearfix'>
            <SmartyContent domainSettings={domainSettings} settings={settings} agentData={agentData} pageData={pageData} theContent={content} phoneNumber={phoneNumbers.number} noSchemaMarkup />
          </div>
        </div>
        {/* <ExitDiscountModal imageCloudSettings={imageCloudSettings} agentData={agentData} /> */}
      </div>
    )
  }
})

module.exports = getPhoneNumbers(LandingPages)



// WEBPACK FOOTER //
// ./_layouts/_templates/content.jsx